export default [
	{
		path: '/dashboard',
		component: () => import('../views/Dashboard')
	},
  {
    path: '/join-us',
    component: () => import('@views/business/join-us/List')
  },
  {
    path: '/partners',
    component: () => import('@views/business/partner/List')
  },
  {
    path: '/partner/:id?',
    component: () => import('@views/business/partner/Store')
  },
  {
    path: '/properties',
    component: () => import('@views/travel/property/List')
  },
  {
    path: '/property/:id?',
    component: () => import('@views/travel/property/Store')
  },
  {
    path: '/property/view/:id',
    component: () => import('@views/travel/property/Store')
  },
  {
    path: '/instructors',
    component: () => import('@views/business/instructor/List')
  },
  {
    path: '/packages',
    component: () => import('@views/travel/package/List')
  },
  {
    path: '/star-packages',
    component: () => import('@views/travel/package/StarList')
  },
  {
    path: '/comp-packages',
    component: () => import('@views/travel/package/CompareList')
  },
  {
    path: '/retreats',
    component: () => import('@views/travel/property/PartnerPropertyList')
  },
  {
    path: '/my-optionals',
    component: () => import('@views/travel/optionals/List')
  },
  {
    path: '/my-optional/:id?',
    component: () => import('@views/travel/optionals/Store')
  },
  {
    path: '/invoices',
    component: () => import('@views/business/invoice/List')
  },
  {
    path: '/package/:id?/:history?/:historyId?',
    name: 'package-edit',
    component: () => import('@views/travel/package/Store')
  },
  {
    path: '/package/copy/:copyId',
    name: 'package-copy',
    component: () => import('@views/travel/package/Store')
  },
  {
    path: '/enquiry/:enquiryId/package/:id?',
    name: 'enquiry-package',
    component: () => import('@views/travel/package/Store')
  },
  {
    path: '/packages/compare',
    name: 'Compare',
    component: () => import('@views/travel/package/Compare')
  },
  {
    path: '/bookings',
    component: () => import('@views/travel/booking/List')
  },

  {
    path: '/bookings-statement/:id',
    component: () => import('@views/travel/booking/pdf')
  },

  {
    path: '/edit-bookings/:id/:packageId?/:currencyCd?',
    component: () => import('@views/travel/booking/store')
  },

  {
    path: '/booking/packages/:bookingRefNo',
    component: () => import('@views/travel/package/List')
  },
  {
    path: '/bookings-tax-invoice/:id',
    component: () => import('@views/travel/booking/tax')
  },
  {
    path: '/bookings-payment-advice/:id',
    component: () => import('@views/travel/booking/advice')
  },


  // {
  //   path: '/property/view/:id',
  //   component: () => import('@views/travel/property/Store')
  // },


  {
    path: '/rate/:id',
    component: () => import('@views/travel/price/Store')
  },
  {
    path: '/qa',
    component: () => import('@views/events/qa/List')
  },
  {
    path: '/qa/:id',
    component: () => import('@views/events/qa/Store')
  },
  {
    path: '/qa/view/:id',
    component: () => import('@views/events/qa/Store')
  },
  {
    path: '/faq',           //for QA
    component: () => import('@views/events/faq/List')
  },
  {
    path: '/faq/add',           //for QA
    component: () => import('@views/events/faq/Store')
  },

  {
    path: '/description',           //for QA
    component: () => import('@views/events/description/Store')
  },


  {
    path: '/enquiry',
    component: () => import('@views/events/enquiry/List')
  },
  {
    path: '/enquiry/add',
    component: () => import('@views/events/enquiry/Add')
  },
  {
    path: '/enquiry/packages/:inquiryId',
    component: () => import('@views/travel/package/List')
  },
  {
    path: '/subscription',
    component: () => import('@views/events/subscription/List')
  },
  {
    path: '/support',
    component: () => import('@views/events/support/List')
  },

  {
    path: '/customers',
    component: () => import('@views/business/customer/List')
  },

  {
    path: '/staff',
    component: () => import('@views/business/staff/List')
  },
  {
    path: '/staff/add',
    component: () => import('@views/business/staff/Store')
  },

  {
    path: '/comissions',
    component: () => import('@views/business/staff/Comissions')
  },


  {
    path: '/termsConditions',
    component: () => import('@views/events/termsConditions/Store')
  },

  {
    path: '/bankAccounts',
    component: () => import('@views/business/bankAccounts/List')
  },

  {
    path: '/add-bank',
    component: () => import('@views/business/add-bank/Store')
  },
  {
    path: '/add-bank/:id?',
    component: () => import('@views/business/add-bank/Store')
  },
  {
    path: '/paymentDetails',
    component: () => import('@views/events/paymentDetails/List')
  },
  {
    path: '/auth/changePassword',
    component: () => import('@views/auth/ChangePassword')
  },
  {
    path: '/partner-registration',
    component: () => import('@views/business/partner/Store')
  },
  {
    path: '/access-denied',
    component: () => import('@views/AccessDenied')
  },
  {
    path: '/payments',
    component: () => import('@views/business/payment/List')
  },
  {
    path: '/direct-payments',
    component: () => import('@views/business/payment/DirectPaymentList')
  },

  {
    path: '/seo-contents',
    component: () => import('@views/events/seo/List')
  },


  // {
  //   path: '/seo/:id?',
  //   component: () => import('@views/events/seo/Store')
  // },

  {
    path: '/seo/:id?',
    component: () => import('@views/events/seo/Store')
  },

  {
    path: '/exchange-rate',
    component: () => import('@views/events/exchangeRate/List')
  },
  {
    path: '/syncDataToElastic',
    component: () => import('@views/travel/package/SyncToES')
  },

  {
    path: '/prospects',
    component: () => import('@views/business/customer/ProspectList')
  },
  {
    path: '/prospect-templates',
    component: () => import('@views/settings/ProspectTemplate')
  },
  {
    name:"directBooking",
    path: '/packages/:id/booking/:currency_cd/:inquiryId?',
    component: () => import('@views/travel/booking/directBooking')
  },
  {
    name:"viewandconfirmbooking",
    path: '/bookings/confirm/:booking_ref_no',
    component: () => import('@views/travel/booking/confirmBooking')
  },

  {
    name:"settings/suggestion",
    path: '/settings/suggestion',
    component: () => import('@views/settings/suggestion')
  },

  {
    name:"settings/packageStatus",
    path: '/settings/packageStatus',
    component: () => import('@views/settings/packageStatus')
  },
  


]



// WEBPACK FOOTER //
// ./src/routers/auth.js